<script>
import NewForm from "./New";
export default {
  mixins: [NewForm],
  data() {
    return {
      edit: true,
    };
  },
  methods: {
    save() {
      if (this.valid) {
        this.$http
          .put(`/skus`, this.form)
          .then((res) => {
            this.form = res.data;
          })
          .then(() => {
            this.$router.go(-1);
          });
      }
    },
    remove() {
      this.$http.delete(`/skus`, this.form).then(() => {
        this.$router.go(-1);
      });
    },
  },
  mounted() {
    console.log(this.$route.query.id);
    var parameter = encodeURIComponent(this.$route.query.id);
    console.log(parameter);
    this.$http.get(`/skus/code?code=${parameter}`).then((res) => {
      this.form = res.data;
    });
  },
};
</script>
